<template>
    <header id="header" class="container">
        <div v-html="htmlContent"></div>
    </header>
</template>

<script>
    import SecTemplateService from '@/services/api/SecTemplate'

    export default {
        name: 'Header',

        data: () => ({
            htmlContent: null
        }),
        created() {
            SecTemplateService.getHeader().then(data => {
                this.htmlContent = data;
            });
        },
        methods: {

        }
    }
</script>
